import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { ItemLineWithInfo } from './ItemLineWIthInfo';

interface ProvidersLines {
  header: string;
  line1?: string;
  line2?: string;
  line3?: string;
}

interface Disclaimer {
  title: string;
  description?: string;
}
interface ProviderCardProps {
  providersLines: ProvidersLines[];
  disclaimer?: Disclaimer;
  providerHeadline: string;
}

export const ProviderCard = ({ providersLines, disclaimer, providerHeadline }: ProviderCardProps) => (
  <div className='p-[24px] pb-[16px] w-full border border-outline-primary-bw-03 rounded-[12px] h-full'>
    <div className='flex flex-col h-full justify-between'>
      <div className='flex flex-col mb-[20px] h-full'>
        <Heading.H10 fontWeight={FontWeight.MEDIUM} className='mb-[6px]' id='provider_headLine'>
          {providerHeadline}
        </Heading.H10>

        {providersLines.map((providerLine) => (
          <ItemLineWithInfo id={providerLine.header} {...providerLine} />
        ))}
      </div>
      {disclaimer?.title && (
        <Heading.H12 id={disclaimer.title} className='text-text-main-secondary justify-end mb-[16px]'>
          {disclaimer.title}
        </Heading.H12>
      )}
      {disclaimer?.description && (
        <div className='pt-[20px] border-t border-bw03 '>
          <Heading.H12 id='disclaimerDescription' className='text-text-main-secondary whitespace-pre-line'>
            {disclaimer.description.split('.').join('.\n')}
          </Heading.H12>
        </div>
      )}
    </div>
  </div>
);
